import { createCancelSource } from '@/http';

export const HTTPCancelMixin = {
  data() {
    return {
      cancelTokenSources: [],
    };
  },
  computed: {
    componentName() {
      return this.$options.name;
    },
  },
  beforeDestroy() {
    this.cancelRequests();
  },
  methods: {
    /**
     * Create a CancelTokenSource for the HTTP request.
     *
     * @returns {CancelTokenSource}
     */
    createCancelTokenSource() {
      const cancelTokenSource = createCancelSource();
      this.cancelTokenSources.push(cancelTokenSource);
      return cancelTokenSource;
    },

    /**
     * Create an object to pass to the API request.
     *
     * @returns {{cancelToken: CancelToken}}
     */
    createCancelTokenOption() {
      return {
        cancelToken: this.createCancelTokenSource().token,
      };
    },

    /**
     * Cancel all registered requests
     */
    cancelRequests() {
      this.cancelTokenSources.forEach((source) => {
        source.cancel(this.componentName);
      });
    },
  },
};
